import { Box, Typography } from "@mui/material";
import { format } from "date-fns";
import { describeEvent } from "./clientDocuments.utils";

const formatMoment = (value) => {
  if (!value) return "";
  try {
    return format(new Date(value), "dd/MM/yyyy HH:mm");
  } catch {
    return "";
  }
};

const DocumentRequestTimeline = ({ events, isLoading, error }) => {
  if (isLoading) {
    return (
      <Typography variant="body2" className="text-app-text-muted">
        Loading activity...
      </Typography>
    );
  }
  if (error) {
    return (
      <Typography variant="body2" color="error">
        {error.message}
      </Typography>
    );
  }
  if (!events || events.length === 0) {
    return (
      <Typography variant="body2" className="text-app-text-muted">
        Nothing has happened on this request yet.
      </Typography>
    );
  }

  return (
    <Box component="ol" className="space-y-2 list-none p-0 m-0">
      {events.map((event) => {
        const { label, actor } = describeEvent(event);
        return (
          <Box component="li" key={event.id} className="flex items-baseline gap-2">
            <Typography variant="caption" className="text-app-text-muted shrink-0 w-32">
              {formatMoment(event.createdAt)}
            </Typography>
            <Typography variant="body2">
              {label} <span className="text-app-text-muted">by {actor}</span>
              {event.detail ? <span className="text-app-text-muted"> ({event.detail})</span> : null}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default DocumentRequestTimeline;
